"use client";
import * as React from "react";
const SvgStarOutlineOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 5.22-5.75-.5L8-.5 5.75 4.73 0 5.22l4.37 3.73-1.31 5.55L8 11.56l4.94 2.94-1.3-5.55zm-8 4.86-3 1.79.8-3.38-2.66-2.27 3.5-.3L8 2.74l1.37 3.19 3.5.3-2.65 2.27.8 3.38z" }));
export {
  SvgStarOutlineOutlined as default
};
